export class EnderecoPessoa {

    codigoEndereco: number;
    codigoLocal: number;
    numeroPredial: string;
    codigoLogradouro: number;
    cep: number;
    complemento: string;
    codigoBairro: number;
    nomE_BAIRRO: string;
    nomeBairro: string;
    uf: string;
    nomeCidade: string;
    nomeLogradouro: string;  
}


// WEBPACK FOOTER //
// ./src/app/models/endereco-pessoa.model.ts